// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    CreateClaimFacility,
    CreateClaimFacilityFromJSON,
    CreateClaimFacilityToJSON,
    CreateClaimGuarantor,
    CreateClaimGuarantorFromJSON,
    CreateClaimGuarantorToJSON,
    CreateClaimPatient,
    CreateClaimPatientFromJSON,
    CreateClaimPatientToJSON,
    CreateClaimProvider,
    CreateClaimProviderFromJSON,
    CreateClaimProviderToJSON,
    CreateClaimSeller,
    CreateClaimSellerFromJSON,
    CreateClaimSellerToJSON,
    CreateClaimSubscriber,
    CreateClaimSubscriberFromJSON,
    CreateClaimSubscriberToJSON,
    GuarantorPayment,
    GuarantorPaymentFromJSON,
    GuarantorPaymentToJSON,
    TemplatePaperwork,
    TemplatePaperworkFromJSON,
    TemplatePaperworkToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportCreateClaimTypePayload
 */
export interface SupportCreateClaimTypePayload {
    /**
     * If provided, it will attempt to update the existing claim if no claim types exist.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    claimId?: string;
    /**
     * Attach the claim to a bundle - useful when working with split claims
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    claimBundleId?: string;
    /**
     * The claim submitter identifier generated from the practice EMR/PMS to uniquely identify the claim.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    controlNumber?: string;
    /**
     * The Enter Chargemaster id.  When included, will validate or fill missing price information for service lines.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    chargemasterId?: string;
    /**
     * The Enter billing Provider id.  Billing providers are setup during enrollment.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    billingProviderId?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateClaimTypePayload
     */
    maximumGuarantorResponsibility?: Amount;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<GuarantorPayment>}
     * @memberof SupportCreateClaimTypePayload
     */
    guarantorPayments?: Array<GuarantorPayment>;
    /**
     * Claim narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    claimNarrative?: string;
    /**
     * The claim-level Clinical Laboratory Improvement Amendment number.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    cliaNumber?: string;
    /**
     * The claim-level referral number.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    referralNumber?: string;
    /**
     * The claim-level primary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    primaryPayerAuthorizationNumber?: string;
    /**
     * The claim-level secondary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    secondaryPayerAuthorizationNumber?: string;
    /**
     * The claim-level tertiary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    tertiaryPayerAuthorizationNumber?: string;
    /**
     * The primary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    primaryThirdPartyAdministratorPayerId?: string;
    /**
     * The secondary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    secondaryThirdPartyAdministratorPayerId?: string;
    /**
     * The tertiary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimTypePayload
     */
    tertiaryThirdPartyAdministratorPayerId?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<CreateClaimSubscriber>}
     * @memberof SupportCreateClaimTypePayload
     */
    subscribers?: Array<CreateClaimSubscriber>;
    /**
     * 
     * OpenAPI data type: {CreateClaimPatient}
     * @type {CreateClaimPatient}
     * @memberof SupportCreateClaimTypePayload
     */
    patient?: CreateClaimPatient;
    /**
     * 
     * OpenAPI data type: {CreateClaimGuarantor}
     * @type {CreateClaimGuarantor}
     * @memberof SupportCreateClaimTypePayload
     */
    guarantor?: CreateClaimGuarantor;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<CreateClaimProvider>}
     * @memberof SupportCreateClaimTypePayload
     */
    providers?: Array<CreateClaimProvider>;
    /**
     * 
     * OpenAPI data type: {CreateClaimSeller}
     * @type {CreateClaimSeller}
     * @memberof SupportCreateClaimTypePayload
     */
    seller?: CreateClaimSeller;
    /**
     * 
     * OpenAPI data type: {CreateClaimFacility}
     * @type {CreateClaimFacility}
     * @memberof SupportCreateClaimTypePayload
     */
    facility?: CreateClaimFacility;
    /**
     * Existing paperwork attachment following this claim
     * OpenAPI data type: {array}
     * @type {Array<TemplatePaperwork>}
     * @memberof SupportCreateClaimTypePayload
     */
    paperwork?: Array<TemplatePaperwork>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportCreateClaimTypePayload
     */
    documents?: Array<string>;
}

export function SupportCreateClaimTypePayloadFromJSON(json: any): SupportCreateClaimTypePayload {
    return {
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'claimBundleId': !exists(json, 'claimBundleId') ? undefined : json['claimBundleId'],
            'controlNumber': !exists(json, 'controlNumber') ? undefined : json['controlNumber'],
            'chargemasterId': !exists(json, 'chargemasterId') ? undefined : json['chargemasterId'],
            'billingProviderId': !exists(json, 'billingProviderId') ? undefined : json['billingProviderId'],
            'maximumGuarantorResponsibility': !exists(json, 'maximumGuarantorResponsibility') ? undefined : AmountFromJSON(json['maximumGuarantorResponsibility']),
            'guarantorPayments': !exists(json, 'guarantorPayments') ? undefined : (json['guarantorPayments'] as Array<any>).map(GuarantorPaymentFromJSON),
            'claimNarrative': !exists(json, 'claimNarrative') ? undefined : json['claimNarrative'],
            'cliaNumber': !exists(json, 'cliaNumber') ? undefined : json['cliaNumber'],
            'referralNumber': !exists(json, 'referralNumber') ? undefined : json['referralNumber'],
            'primaryPayerAuthorizationNumber': !exists(json, 'primaryPayerAuthorizationNumber') ? undefined : json['primaryPayerAuthorizationNumber'],
            'secondaryPayerAuthorizationNumber': !exists(json, 'secondaryPayerAuthorizationNumber') ? undefined : json['secondaryPayerAuthorizationNumber'],
            'tertiaryPayerAuthorizationNumber': !exists(json, 'tertiaryPayerAuthorizationNumber') ? undefined : json['tertiaryPayerAuthorizationNumber'],
            'primaryThirdPartyAdministratorPayerId': !exists(json, 'primaryThirdPartyAdministratorPayerId') ? undefined : json['primaryThirdPartyAdministratorPayerId'],
            'secondaryThirdPartyAdministratorPayerId': !exists(json, 'secondaryThirdPartyAdministratorPayerId') ? undefined : json['secondaryThirdPartyAdministratorPayerId'],
            'tertiaryThirdPartyAdministratorPayerId': !exists(json, 'tertiaryThirdPartyAdministratorPayerId') ? undefined : json['tertiaryThirdPartyAdministratorPayerId'],
            'subscribers': !exists(json, 'subscribers') ? undefined : (json['subscribers'] as Array<any>).map(CreateClaimSubscriberFromJSON),
            'patient': !exists(json, 'patient') ? undefined : CreateClaimPatientFromJSON(json['patient']),
            'guarantor': !exists(json, 'guarantor') ? undefined : CreateClaimGuarantorFromJSON(json['guarantor']),
            'providers': !exists(json, 'providers') ? undefined : (json['providers'] as Array<any>).map(CreateClaimProviderFromJSON),
            'seller': !exists(json, 'seller') ? undefined : CreateClaimSellerFromJSON(json['seller']),
            'facility': !exists(json, 'facility') ? undefined : CreateClaimFacilityFromJSON(json['facility']),
            'paperwork': !exists(json, 'paperwork') ? undefined : (json['paperwork'] as Array<any>).map(TemplatePaperworkFromJSON),
            'documents': !exists(json, 'documents') ? undefined : json['documents'],
    };

}

export function SupportCreateClaimTypePayloadToForm(value?: SupportCreateClaimTypePayload): any {
    let jsonVal = SupportCreateClaimTypePayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateClaimTypePayloadToJSON(value?: SupportCreateClaimTypePayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'claimBundleId': cleanupBlankValuesForBackend(value.claimBundleId),
            'controlNumber': cleanupBlankValuesForBackend(value.controlNumber),
            'chargemasterId': cleanupBlankValuesForBackend(value.chargemasterId),
            'billingProviderId': cleanupBlankValuesForBackend(value.billingProviderId),
            'maximumGuarantorResponsibility': AmountToJSON(value.maximumGuarantorResponsibility),
            'guarantorPayments': (value.guarantorPayments === undefined || value.guarantorPayments === null) ? undefined : (value.guarantorPayments as Array<any>).map(GuarantorPaymentToJSON),
            'claimNarrative': cleanupBlankValuesForBackend(value.claimNarrative),
            'cliaNumber': cleanupBlankValuesForBackend(value.cliaNumber),
            'referralNumber': cleanupBlankValuesForBackend(value.referralNumber),
            'primaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.primaryPayerAuthorizationNumber),
            'secondaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.secondaryPayerAuthorizationNumber),
            'tertiaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.tertiaryPayerAuthorizationNumber),
            'primaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.primaryThirdPartyAdministratorPayerId),
            'secondaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.secondaryThirdPartyAdministratorPayerId),
            'tertiaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.tertiaryThirdPartyAdministratorPayerId),
            'subscribers': (value.subscribers === undefined || value.subscribers === null) ? undefined : (value.subscribers as Array<any>).map(CreateClaimSubscriberToJSON),
            'patient': CreateClaimPatientToJSON(value.patient),
            'guarantor': CreateClaimGuarantorToJSON(value.guarantor),
            'providers': (value.providers === undefined || value.providers === null) ? undefined : (value.providers as Array<any>).map(CreateClaimProviderToJSON),
            'seller': CreateClaimSellerToJSON(value.seller),
            'facility': CreateClaimFacilityToJSON(value.facility),
            'paperwork': (value.paperwork === undefined || value.paperwork === null) ? undefined : (value.paperwork as Array<any>).map(TemplatePaperworkToJSON),
            'documents': cleanupBlankValuesForBackend(value.documents),
    };
}


